import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { StockReturnRequestProvider } from '../centerWarehouse/stockReturnRequestReceive/ContextAPI';
import Index from '../centerWarehouse/stockReturnRequestReceive/Index';
import PermissionDenied from './PermissionDenied';

export default function StockReturnRequestCentralReceive() {
    // Route Permission
    const { auth } = useAuth();
    const { route_permissions } = auth;
    if (!route_permissions['stock-return-request-central-receive']) return <PermissionDenied />;

    return (
        <StockReturnRequestProvider>
            <Index />
        </StockReturnRequestProvider>
    );
}
